export function pillClass(s) {
  return (
    {
      due_now: "pill-due",
      no_show: "pill-due",
      rescheduled: "pill-due",
      active: "pill-active",
      cancelled: "pill-red",
      upcoming: "pill-up",
      completed: "pill-up",
      approved: "pill-up",
      charging: "pill-up",
      "in-progress": "pill-up",
    }[s] || ""
  );
}

export function getDuration(startTime) {
  const now = new Date();

  const [hours, minutes, seconds] = startTime.split(":").map(Number);

  const target = new Date();
  target.setHours(hours, minutes, seconds, 0);

  // Difference in milliseconds
  const diff = target.getTime() - now.getTime();

  const totalMinutes = Math.round(diff / (1000 * 60));

  if (totalMinutes <= 0) {
    return "Started";
  }

  if (totalMinutes < 60) {
    return `In ${totalMinutes} min`;
  }

  const totalHours = Math.round((totalMinutes / 60) * 10) / 10;

  return `In ${totalHours} hour${totalHours !== 1 ? "s" : ""}`;
}

export function getDurationInMin(time) {
  const now = new Date();

  const [hours, minutes, seconds] = time.split(":").map(Number);

  const target = new Date();
  target.setHours(hours, minutes, seconds || 0, 0);

  // Difference in minutes
  const diff = target.getTime() - now.getTime();

  const result = Math.round(diff / (1000 * 60)) | 0;
  return result > 0 ? result : 0;
}

// Convert duration in minutes into [{ value, unit }]
export function convertDuration(totalMinutes) {
  const result = [];

  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours > 0) {
    result.push({
      value: hours,
      unit: hours === 1 ? "hour" : "hours",
    });
  }

  if (minutes > 0) {
    result.push({
      value: minutes,
      unit: minutes === 1 ? "min" : "mins",
    });
  }

  // Handle 0 minutes
  if (result.length === 0) {
    result.push({
      value: 0,
      unit: "min",
    });
  }

  return result;
}
